
<template>
	<div class="container-fluid content">
    <div class="row">
      <div class="col-md-4 col-md-offset-4">

          <h4><span>{{ $t('Restablecer contraseña') }}</span></h4>

          <template v-if=" !getTokenRestablecerContrasena ">
            <p v-html="$t('Introduce a continuación tu <b>nombre de usuario</b> que utilizas para iniciar sesión y te enviaremos un email con las instrucciones para restablecer la contraseña.')"></p>
            
            <form method="post" v-on:submit.prevent="onSubmit">
              <div class="form-head fix">
                <div class="input-group">
                  <div class="input-group-addon"><i class="fa fa-user-circle-o"></i></div>
                    <input type="text" class="form-control" :placeholder="$t('Nombre de usuario')" maxlength="150" required="" autofocus v-model="nombreUsuario">
                </div>
              </div>

              <div v-if="loading" class="loading center"><img src="@/assets/img/loading.gif" alt=""></div>

              <div v-if="frm_success" class="frm-success">{{ frm_success_message }}</div>
              <div v-if="frm_error" class="frm-error">{{ frm_error_message }}</div>

              <div class="center">
                <button class="btn btn-tata mb40" type="submit" :disabled="loading">{{ $t('Restablecer contraseña') }} <i class="fa fa-angle-double-right"></i></button>
              </div>
            </form>

          </template>

          <form v-else method="post" v-on:submit.prevent="cambiarContrasena">
            <div class="form-head fix">
              <div class="input-group">
                <div class="input-group-addon"><i class="fa fa-lock"></i></div>
                  <input type="password" class="form-control" :placeholder="$t('Contraseña nueva')" maxlength="150" required="" v-model="biblioteca.contrasena_nueva" pattern=".{8,}" title="La contraseña nueva debe tener una longitud mínima de 8 caracteres!">
              </div> 
              <div class="input-group">
                <div class="input-group-addon"><i class="fa fa-lock"></i></div>
                  <input type="password" class="form-control" :placeholder="$t('Confirmación contraseña')" maxlength="150" required="" v-model="biblioteca.contrasena_confirmacion">
              </div>              
            </div>

            <div class="comment center">{{ $t('La contraseña nueva debe tener una longitud mínima de 8 caracteres!') }}</div>

            <div v-if="loading2" class="loading center"><img src="@/assets/img/loading.gif" alt=""></div>

            <div v-if="frm_success2" class="frm-success">{{ frm_success_message2 }}</div>
            <div v-if="frm_error2" class="frm-error">{{ frm_error_message2 }}</div>

            <div class="center">
              <button class="btn btn-tata mb40 mt20" type="submit" :disabled="loading2 || updated">{{ $t('Actualizar contraseña') }} <i class="fa fa-angle-double-right"></i></button>
            </div>
          </form>

      </div>

      <div class="col-md-4">
        <!-- <pre>{{ $data }}</pre> -->
      </div>

    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "Restablecer contraseña": "Restablecer contraseña",
    "Introduce a continuación tu <b>nombre de usuario</b> que utilizas para iniciar sesión y te enviaremos un email con las instrucciones para restablecer la contraseña.": "Introduce a continuación tu <b>nombre de usuario</b> que utilizas para iniciar sesión y te enviaremos un email con las instrucciones para restablecer la contraseña.",
    "Nombre de la biblioteca": "Nombre de la biblioteca",
    "Nombre de usuario": "Nombre de usuario",
    "La contraseña nueva debe tener una longitud mínima de 8 caracteres!": "La contraseña nueva debe tener una longitud mínima de 8 caracteres!",
    "Contraseña nueva": "Contraseña nueva",
    "El nombre de usuario debe tener una longitud mínima de 3 caracteres.": "El nombre de usuario debe tener una longitud mínima de 3 caracteres.",
    "Confirmación contraseña": "Confirmación contraseña",
    "Actualizar contraseña": "Actualizar contraseña",
    "La contraseña nueva y la confirmación no coinciden!": "La contraseña nueva y la confirmación no coinciden!"
  },
  "en": {
    
  },
  "ca": {
    "Restablecer contraseña": "Restablir contrasenya",
    "Introduce a continuación tu <b>nombre de usuario</b> que utilizas para iniciar sesión y te enviaremos un email con las instrucciones para restablecer la contraseña.": "Introdueix a continuació el teu <b>nom d'usuari</b> que fas servir per iniciar sessió i t'enviarem un email amb les instruccions per restablir la contrasenya.",
    "Nombre de la biblioteca": "Nom de la biblioteca",
    "Nombre de usuario": "Nom d’usuari",
    "Email / nombre de usuario": "Email / nom d’usuari",
    "La contraseña nueva debe tener una longitud mínima de 8 caracteres!": "La contrasenya nova ha de tenir una longitud mínima de 8 caràcters!",
    "Contraseña nueva": "Contrasenya nova",
    "El nombre de usuario debe tener una longitud mínima de 3 caracteres.": "El nom d'usuari ha de tenir una longitud mínima de 3.",
    "Confirmación contraseña": "Confirmació contrasenya",
    "Actualizar contraseña": "Actualitzar contrasenya",
    "La contraseña nueva y la confirmación no coinciden!": "La contrasenya nova i la confirmació no coincideixen!"
  }
}
</i18n>

<script>
  import axios from 'axios'; 
  import { mapGetters } from 'vuex';

	export default {
		data: () => {
			return{
        nombreUsuario: '',      
        biblioteca: {
          contrasena_nueva: '',
          contrasena_confirmacion: '',
        },
        frm_response: '',
        frm_success: false,
        frm_success_message: '',
        frm_error: false,
        frm_error_message: '',
        frm_success2: false,
        frm_success_message2: '',
        frm_error2: false,
        frm_error_message2: '',
        loading: false,
        loading2: false,
        updated: false
			}
		},
    computed: mapGetters(['getApiUrl', 'getLocale', 'getTokenRestablecerContrasena']), 
    methods: {
      onSubmit(){
        if( this.nombreUsuario.length < 3 ){
          this.frm_error_message = this.$t('El nombre de usuario debe tener una longitud mínima de 3 caracteres.');
          this.frm_error = true;
        }else{
          this.frm_success = false;
          this.frm_error = false;
          this.showLoading();

          axios.post(this.getApiUrl + this.getLocale + '/restablecer-contrasena', {
            nombreUsuario: this.nombreUsuario,
          })
          .then( (response) => {
            this.hideLoading();
            this.frm_success_message = response.data.msg;
            this.frm_success = true;   
            this.clearFormData();
          })
          .catch( (error) => {
            this.frm_error_message = error.response.data.status + ' ' + error.response.data.msg;
            this.frm_error = true;
            this.hideLoading();
          });

        }
      },
      cambiarContrasena(){
        if( this.biblioteca.contrasena_nueva.length < 8 ){
          this.frm_error_message = this.$t('La contraseña nueva debe tener una longitud mínima de 8 caracteres!');
          this.frm_error = true;
        }else if( this.biblioteca.contrasena_nueva != this.biblioteca.contrasena_confirmacion ){
          this.frm_error_message2 = this.$t('La contraseña nueva y la confirmación no coinciden!');
          this.frm_error2 = true;
        }else{
          this.frm_success2 = false;
          this.frm_error2 = false;
          this.showLoading();

          axios.post(this.getApiUrl + this.getLocale + '/restablecer-contrasena', {
            contrasena_nueva:           this.biblioteca.contrasena_nueva,
            contrasena_confirmacion:    this.biblioteca.contrasena_confirmacion,
            token:                      this.getTokenRestablecerContrasena
          })
          .then( (response) => {
            this.hideLoading();
            this.frm_success_message2 = response.data.msg;
            this.frm_success2 = true;   
            this.clearFormData();  
            this.updated = true;            
          })
          .catch( (error) => {
            this.frm_error_message2 = error.response.data.status + ' ' + error.response.data.msg;
            this.frm_error2 = true;
            this.hideLoading();
          });
        }
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
      clearFormData(){
        this.nombreUsuario = '';
      }
    },
    watch: {
    }
  }
</script>
